import { render, staticRenderFns } from "./CImageCropperModal.vue?vue&type=template&id=b08869d4&scoped=true&"
import script from "./CImageCropperModal.vue?vue&type=script&lang=ts&"
export * from "./CImageCropperModal.vue?vue&type=script&lang=ts&"
import style0 from "./CImageCropperModal.vue?vue&type=style&index=0&id=b08869d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08869d4",
  null
  
)

export default component.exports